import { createFileRoute } from "@tanstack/react-router";
import { InvisalignMiamiFlPage } from "~/components/live-seo/pages/InvisalignMiamiFlPage";

// A dedicated route lets Start load this page without the generic renderer bank,
// while still including the component's stylesheet during SSR.
export const Route = createFileRoute("/invisalign-miami-fl")({
	head: async () =>
		(await import("~/utils/liveSeoHead")).headFromLiveSeo(
			"/invisalign-miami-fl",
		),
	component: InvisalignMiamiFlPage,
});
